import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';

import {ArrayResponse, ExternalLink, SendBackResult} from '..';


import {AppSettingsService} from './app-settings.service';
import {BaseRestService} from './base-rest.service';
import {DUMMY_ALLOWED} from '../../client-dummy';

@Injectable()
export class ExternalLinksService extends BaseRestService {
  constructor(http: HttpClient, appSettingsService: AppSettingsService) { super(http, appSettingsService); }

  protected get className(): string { return 'ExternalLinksService'; }

  protected get isAnonymous(): boolean { return false; }

  getList(clientId: string): Observable<SendBackResult<ArrayResponse<ExternalLink>>> {
    return of(DUMMY_ALLOWED);
    // return this.get<ArrayResponse<ExternalLink>>(`/clients/${clientId}/applications/allowed`);  // TODO: not remove
  }
}
